import { locale } from 'services/locale/en';
import { languages } from 'services/locale';
import { errors } from 'projects-translates-errors';

export const initialState = { locale: { ...locale, errorMessages: errors.en }, lang: languages.en };
